/**
 * Created by Victor Rojo on 21/9/17.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';


import {CloudUser} from "../model/cloudUser";

@Injectable()
export class CloudUserService{

  private basePath = "api/v1/cloud_user/";
  constructor(
    private http: HttpClient
  ) {}

  private errorHandler(error:any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.error || error);
  }

  get(id: string):Promise<any> {
    let url = this.basePath + id;
    return this.http
      .get(url)
      .toPromise()
      .then( response => response as CloudUser )
      .catch(error => this.errorHandler(error));
  }

  list():Promise<any> {
    let url = this.basePath;
    return this.http
      .get(url)
      .toPromise()
      .then( response => response as CloudUser[] )
      .catch(error => this.errorHandler(error));
  }

  put(cloudUser: CloudUser):Promise<any> {
    let url = this.basePath + cloudUser.idCloudUser;
    return this.http
      .put(url, cloudUser)
      .toPromise()
      .then( response => response as CloudUser )
      .catch(error => this.errorHandler(error));
  }

  create(cloudUser: {}):Promise<any> {
    let url = this.basePath;
    return this.http
      .post(url, cloudUser)
      .toPromise()
      .then( response => response as CloudUser )
      .catch(error => this.errorHandler(error));
  }

  patch(id: string, data:any):Promise<any> {
    let url = this.basePath + id;
    return this.http
      .patch(url, data, { responseType: 'text' }) //Hack for new HttpClient that automatically runs .json() on response
      .toPromise()
      .catch(error => this.errorHandler(error));
  }

  delete(id: string):Promise<any>{
    let url = this.basePath + id;
    return this.http
      .delete(url, { responseType: 'text' })
      .toPromise()
      .catch(error => this.errorHandler(error));
  }

  changePassword(id: string, data:any):Promise<any> {
    let url = this.basePath + id + "/password-change";
    return this.http
      .post(url, data, { responseType: 'text' })
      .toPromise()
      .catch(error => this.errorHandler(error));
  }

  check(filter: string):Promise<any> {
    let url = this.basePath + "check?field=" +  filter;
    return this.http
      .get(url)
      .toPromise()
      .catch(error => this.errorHandler(error));
  }
}
